/* UI */

export const headerHeight = 200;
export const fullContentHeight = `calc(100vh - ${headerHeight}px)`;

/* Value Lists */

export const gigStatuses = [
  'Pre-inquiry',
  'Check Availability',
  'Check General Availability',
  'Offered',
  'Offered (Travel)',
  'Available',
  'Unavailable',
  'Booked',
  'Confirm Details',
  'Reconfirm Details',
  'Details Confirmed',
  'Event Reminder',
  'Released',
  'Cancelled'
];

// Status groups for showing details
export const statusesWithPreliminaryDetails = [
  'Check Availability',
  'Check General Availability', 
  'Offered',
  'Offered (Travel)',
  'Booked',
  'Available',
  'Unavailable'
];

export const statusesWithFullDetails = [
  'Details Confirmed',
  'Confirm Details', 
  'Reconfirm Details',
  'Event Reminder'
];

// Combined list for TalentView showDetails logic
export const statusesWithAnyDetails = [
  ...statusesWithPreliminaryDetails,
  ...statusesWithFullDetails
];

/* Client Form Reminder Options */

export const REMINDER_OPTIONS = [
  { value: 'none', label: 'No Reminder' },
  { value: '1w', label: '1 Week' },
  { value: '2w', label: '2 Weeks' },
  { value: '3w', label: '3 Weeks' },
  { value: '1m', label: '1 Month' },
  { value: '2m', label: '2 Months' },
  { value: '3m', label: '3 Months' },
] as const;

export type ReminderOption = typeof REMINDER_OPTIONS[number]['value'];

/* Client Form Auto-Populate Options */

import type { AutoPopulateSource, FieldType } from '../../shared/types/appTypes';

export const AUTO_POPULATE_OPTIONS: Array<{
  value: AutoPopulateSource;
  label: string;
  compatibleTypes: FieldType[];
}> = [
  { value: 'friendlyTitle', label: 'Event Title', compatibleTypes: ['shortText', 'longText'] },
  { value: 'venueInfo', label: 'Venue Info', compatibleTypes: ['shortText', 'longText'] },
  { value: 'timingInfo', label: 'Timing Info', compatibleTypes: ['shortText', 'longText'] },
  { value: 'dayliteData.forecasted', label: 'Event Date (Daylite)', compatibleTypes: ['shortText', 'longText', 'date'] },
];
